export const SET_STATUSES = 'SET_STATUSES'
export const SET_SELECTED_STATUESES = 'SET_SELECTED_STATUESES'
export const SET_USER_GROUPS = 'SET_USER_GROUPS'
export const SET_USER_GROUPS_COURSES = 'SET_USER_GROUPS_COURSES'
export const SET_GROUP_COURSES_STATUS = 'SET_GROUP_COURSES_STATUS'
export const SET_USER_PROGRESS = 'SET_USER_PROGRESS'
export const SET_GROUP_DATA = 'SET_GROUP_DATA'
export const SET_SELECTED_STATUESES_NR = 'SET_SELECTED_STATUESES_NR'
export const SET_PAST_DUE = 'SET_PAST_DUE'
export const SET_PAST_DUE_BOOL = 'SET_PAST_DUE_BOOL'
export const SET_SELECTED_COURSE_TYPE = 'SET_SELECTED_COURSE_TYPE'
export const SET_SELECTED_COURSE_TYPE_VALUES = 'SET_SELECTED_COURSE_TYPE_VALUES'
export const SET_SEARCH_VALUE = 'SET_SEARCH_VALUE'
export const SET_COURSES_DATA = 'SET_COURSES_DATA'
export const SET_REPORTS_LOADING = 'SET_REPORTS_LOADING'
export const SET_SEARCH_VALUE_ON_CLICK = 'SET_SEARCH_VALUE_ON_CLICK'